import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import {Product} from '../../../Models/product';
import {ProductService} from '../../../Services/product.service';
import {Response} from '../../../Models/response';


@Injectable({
  providedIn: 'root'
})
export class ProductResolver  {
  constructor(private productService: ProductService) { }

  resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    const id = Number(route.paramMap?.get('id') ?? 0);
    return this.productService.productById(id);
  }
}

